class mCardAddress extends HTMLDivElement {
    constructor() {
        super();
        this.updateButton = this.querySelector('.update-address-btn');
        this.removeButton = this.querySelector('.remove-address-btn');
        this.deleteButtons = this.querySelectorAll('.remove-address-btn');
        this.preferedAddressCheckbox = this.querySelector('.is-prefered-address');
        this.setPreferedAddress = this.setPreferedAddress.bind(this);
    }

    connectedCallback() {
        this.deleteButtons.forEach((el) => {
            el.addEventListener('click', this.setupRemoveModal);
        });
        this.preferedAddressCheckbox.addEventListener('change', this.setPreferedAddress);
    }

    setupRemoveModal(e) {
        const removeModal = document.querySelector('#m-popin-remove-item-address');
        const confirmDelete = removeModal.querySelector('[data-component-confirm-delete]');
        const action = e.currentTarget.getAttribute('data-action');
        if (action) {
            confirmDelete.setAttribute('href', action);
        }
    }

    setPreferedAddress() {
        if (this.preferedAddressCheckbox.checked) {
            const url = this.preferedAddressCheckbox.getAttribute('data-action');
            fetch(url, {
                method: 'GET'
            }).then((response) => {
                return response.text();
            }).then((responseData) => {
                let container = this.closest('[data-page-content-container]');
                container.innerHTML = responseData;
            });
        }
    }
}

customElements.define('m-card-address', mCardAddress, {
    extends: 'div'
});
